import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIList from 'UIComponents/list/UIList';
import { Text } from 'foundations-components/components/Text';
import { Box } from 'foundations-components/transitional/components/Box';
import { Flex } from 'foundations-components/components/Flex';
import GoToProcessorPickerButton from 'payments-enrollment-embed-lib/buttons/GoToProcessorPickerButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollInHubSpotPaymentsInvoicesModal = ({
  handleInterstitialModalClose,
  screen,
  subscreen
}) => {
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "conversational",
    width: 1000,
    "data-test-id": "enroll-invoices-modal",
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      "data-test-id": "enroll-invoices-modal-close-button",
      onClick: handleInterstitialModalClose
    }), /*#__PURE__*/_jsxs(UIFlex, {
      className: "p-all-10",
      children: [/*#__PURE__*/_jsxs(Box, {
        inlineSize: "60%",
        children: [/*#__PURE__*/_jsx(UIDialogHeader, {
          children: /*#__PURE__*/_jsxs(Flex, {
            flexDirection: "column",
            children: [/*#__PURE__*/_jsx(Text, {
              as: "h4",
              textAlign: "start",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "embedPoints.invoicesEnrollInHubSpotPaymentsModal.enrollInHubSpotPayments"
              })
            }), /*#__PURE__*/_jsx(Text, {
              as: "h2",
              textAlign: "start",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "embedPoints.invoicesEnrollInHubSpotPaymentsModal.collectPaymentsWithInvoices"
              })
            })]
          })
        }), /*#__PURE__*/_jsxs(UIDialogBody, {
          children: [/*#__PURE__*/_jsx(Text, {
            as: "p",
            marginBlockEnd: "300",
            textAlign: "start",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "embedPoints.invoicesEnrollInHubSpotPaymentsModal.acceptOnlinePayments"
            })
          }), /*#__PURE__*/_jsx(Text, {
            as: "p",
            textAlign: "start",
            children: /*#__PURE__*/_jsxs(UIList, {
              styled: true,
              children: [/*#__PURE__*/_jsx(FormattedMessage, {
                message: "embedPoints.invoicesEnrollInHubSpotPaymentsModal.bullet1"
              }), /*#__PURE__*/_jsx(FormattedMessage, {
                message: "embedPoints.invoicesEnrollInHubSpotPaymentsModal.bullet2"
              }), /*#__PURE__*/_jsx(FormattedMessage, {
                message: "embedPoints.invoicesEnrollInHubSpotPaymentsModal.bullet3"
              })]
            })
          }), /*#__PURE__*/_jsx(Text, {
            as: "p",
            textAlign: "start",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "embedPoints.invoicesEnrollInHubSpotPaymentsModal.connectPaymentProcessor"
            })
          })]
        }), /*#__PURE__*/_jsx(UIDialogFooter, {
          children: /*#__PURE__*/_jsx(GoToProcessorPickerButton, {
            use: "primary",
            sourceApp: screen,
            openInCommerceHome: true,
            location: subscreen || 'embed-point-enroll-payments-invoices-modal',
            block: false
          })
        })]
      }), /*#__PURE__*/_jsx(Box, {
        alignSelf: "center",
        inlineSize: "30%",
        children: /*#__PURE__*/_jsx(UIIllustration, {
          alt: "Illustration of a computer screen with a payment link",
          name: "payments-button",
          width: "100%"
        })
      })]
    })]
  });
};
export default EnrollInHubSpotPaymentsInvoicesModal;